<div class="viewer-layout">
    <div class="side-toolbar">
        <button [class.active]="activeTool === 'Wwwc'" (click)="setActiveTool('Wwwc')" title="Window/Level">
            <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2v20a10 10 0 0 0 0-20z" fill="currentColor" />
            </svg>
        </button>

        <button [class.active]="activeTool === 'Zoom'" (click)="setActiveTool('Zoom')" title="Zoom">
            <svg viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                <line x1="11" y1="8" x2="11" y2="14" />
                <line x1="8" y1="11" x2="14" y2="11" />
            </svg>
        </button>

        <button [class.active]="activeTool === 'Pan'" (click)="setActiveTool('Pan')" title="Pan">
            <svg viewBox="0 0 24 24">
                <polyline points="5 9 2 12 5 15" />
                <polyline points="9 5 12 2 15 5" />
                <polyline points="15 19 12 22 9 19" />
                <polyline points="19 9 22 12 19 15" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <line x1="12" y1="2" x2="12" y2="22" />
            </svg>
        </button>

        <button [class.active]="activeTool === 'Length'" (click)="setActiveTool('Length')" title="Length">
            <svg viewBox="0 0 24 24">
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="9" x2="3" y2="15" />
                <line x1="21" y1="9" x2="21" y2="15" />
            </svg>
        </button>

        <button [class.active]="activeTool === 'Angle'" (click)="setActiveTool('Angle')" title="Angle">
            <svg viewBox="0 0 24 24">
                <path d="M22 19H4.4L13 6" />
                <path d="M8 19c0-2.2 1.8-4 4-4" />
            </svg>
        </button>

        <div class="side-divider"></div>

        <button (click)="resetView()" title="Reset">
            <svg viewBox="0 0 24 24">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                <polyline points="3 3 3 8 8 8" />
            </svg>
        </button>

        <button (click)="invertImage()" title="Invert">
            <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" />
                <path d="M22 12A10 10 0 0 1 12 22V2a10 10 0 0 1 10 10z" fill="currentColor" />
            </svg>
        </button>

        <button (click)="clearMeasurements()" title="Clear">
            <svg viewBox="0 0 24 24">
                <path d="M3 6h18" />
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
            </svg>
        </button>
    </div>

    <div class="viewer-main">
        <div #container class="dicom-container"></div>

        <div class="info-overlay" *ngIf="imageInfo">
            <div class="info-item">{{ imageInfo.patientName }}</div>
            <div class="info-item">{{ imageInfo.studyDate }}</div>
            <div class="info-item">{{ imageInfo.modality }}</div>
        </div>
    </div>
</div>